import { useEffect, useState } from 'react'

// Server-safe media query: always false on the server and on the first client
// render, then the real value once mounted.
export const useMediaQuery = (query: string): boolean => {
    const [matches, setMatches] = useState(false)

    useEffect(() => {
        const media = window.matchMedia(query)
        const update = () => setMatches(media.matches)

        update()
        media.addEventListener('change', update)

        return () => {
            media.removeEventListener('change', update)
        }
    }, [query])

    return matches
}

export const useIsDesktop = (): boolean => useMediaQuery('(min-width: 1024px)')
